import React, { useEffect, useState } from 'react';
import "./AboutUs.css"
import axios from 'axios';
import { Link } from 'react-router-dom';
import { TfiEmail } from "react-icons/tfi";
import { ImMobile } from "react-icons/im";
import { TfiLocationPin } from "react-icons/tfi";
import { SlSocialFacebook } from "react-icons/sl";
import { CgInstagram } from "react-icons/cg";


const AboutUs = () => {
    const API_BASE_URL = process.env.REACT_APP_API_KEY;
    
    const [outletinfo, setOutletInfo] = useState([]);

   const storedData = JSON.parse(localStorage.getItem("outletdataLocal")) || {};

let outletId, outletlogo;

if (storedData.data && Array.isArray(storedData.data) && storedData.data.length > 0) {
  outletId = storedData.data[0].outletId;
  outletlogo = storedData.data[0].outletlogo;
} else if (storedData && typeof storedData === "object" && storedData.outletId) {
  outletId = storedData.outletId;
  outletlogo = storedData.outletlogo;
}

    



    const apiOutletInfo = async () => {
    

        try {
            const response = await axios.get(`${API_BASE_URL}OutletInfo/GetOutletInfoByOutletId?outletId=${outletId}`);
            setOutletInfo(response.data)
            
        } catch (error) {
            console.error("Error fetching outlet info:", error);
        }
    };
    



    useEffect(() => {
        apiOutletInfo()
    }, []);
   
    return (
        <>
            <div className="container-fluid ">
                <div className="col-md-12">
                    <div className="row">
                        {outletinfo.map((oinfo) => (
                            <>
                                <div key={oinfo.outletId} className="col-12 text-center background">
                                    <h2 className="OutletName mt-2">{oinfo.outletName}<br /><span className='osnmStyle'>{oinfo.outletSubName}</span></h2>
                                    <p className='otypetyle'>{oinfo.outleType}</p>
                                </div>
                                <div className='text-center oibodyBackground border-top border-bottom border-dark'>
                                    <p className='oiBody'>Our Dining Policies</p>
                                    <div className='text-center mb-2'>
                                        <p className="content-item">{oinfo.orderTime}</p>
                                        <p className="content-item">{oinfo.orderCancle}</p>
                                        <p className="content-item">{oinfo.orderAvailable}</p>
                                        <p className="content-item">{oinfo.alergiesInfo}</p>
                                        <p className="content-item">{oinfo.outsideFood}</p>
                                        <p className="content-item">{oinfo.outletTimings}</p>
                                        <p className="content-item">{oinfo.taxType}</p>
                                        <p className="content-item">{oinfo.gstin}<br /> {oinfo.vatTin} {oinfo.fssai}</p>
                                    </div>
                                    <div className='border-top border-dark'>
                                        <p className='oiBody mt-2'>Stay Connected @</p>
                                        <p className='mt-2 content-item'><TfiEmail /> -- {oinfo.outletEmail}</p>
                                        <p className='content-item mb-1'><ImMobile /> -- {oinfo.outletPhone}</p>
                                        <p className='content-item'><TfiLocationPin /> -- {oinfo.outletAdd1}</p>
                                        <p className='content-item mb-2'>{oinfo.outletAdd2}</p>
                                    </div>


                                </div>
                                <div className='text-center border-bottom border-dark'>
                                    <p className='oiBody mt-2 mb-2'>Follow Us @.....
                                        <Link to={oinfo.faceBook} >
                                            <SlSocialFacebook size={25} className='me-2' />
                                        </Link>
                                        <Link to={oinfo.instagram} className="instagram-icon" >
                                            <CgInstagram size={25} />
                                        </Link>
                                    </p>
                                </div>
                                <div className='footercss'>
                                    <p>
                                        Powered By - Billtrace Multilink Solutions -
                                        <a href="tel:9819622574" style={{ textDecoration: 'none', color: 'inherit' }}>
                                            9819622574
                                        </a>
                                    </p>

                                </div>
                            </>


                        ))}
                    </div>
                </div>
            </div>


        </>

    );
}

export default AboutUs;
